/* iron-checkkit LP page behavior — theme asset.
   Load ONLY on product 101329 via a {% if product.handle == '101329' %} conditional. */

/* YouTube view tracking (GTM dataLayer); callback must be global, so this stays top-level */
window.dataLayer = window.dataLayer || [];
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
function onYouTubeIframeAPIReady() {
  player = new YT.Player('iframePlayer-2703479287706710498', {
    events: {
      'onStateChange': function(event) {
        if (event.data == YT.PlayerState.PLAYING) {
          // 再生
          dataLayer.push({
            'event' : 'youtube_start',
            'video_id' : '6MWq5qHsvhE'
          });
        } else if (event.data == YT.PlayerState.ENDED) {
          // 完全視聴
          dataLayer.push({
            'event' : 'youtube_end',
            'video_id' : '6MWq5qHsvhE'
          });
        } else if (event.data == YT.PlayerState.PAUSED) {
          // 一時停止
          var ct = player.getCurrentTime();
          dataLayer.push({
            'event' : 'youtube_pause',
            'video_id' : '6MWq5qHsvhE',
            'video_current_time' : ct
          });
        }
      }
    }
  });
}

/* sliders + modals: run once the DOM is ready — safe under defer, async, or plain loading */
function ironCheckkitInit() {
/* Static port of sofybe.jp iron-checkkit page behavior (slick sliders / info modal / EC modal) */
(function () {
  function isSp() { return window.matchMedia("(max-width: 768px)").matches; }

  /* generic mini-slick: wires arrows/swipe on a container whose DOM is already
     in slick structure (.slick-list > .slick-track > .slick-slide) */
  function wire(slider, perViewFn) {
    var track = slider.querySelector(".slick-track");
    var slides = Array.prototype.slice.call(track.children);
    var prev = slider.querySelector(".slick-prev");
    var next = slider.querySelector(".slick-next");
    var cur = 0;
    function maxIndex() { return Math.max(0, slides.length - perViewFn()); }
    function render(animate) {
      if (cur > maxIndex()) cur = maxIndex();
      track.style.transition = animate ? "transform .5s ease" : "";
      track.style.transform = "translate3d(" + (-slides[cur].offsetLeft) + "px, 0px, 0px)";
      slides.forEach(function (s, i) {
        var active = i >= cur && i < cur + perViewFn();
        s.classList.toggle("slick-current", i === cur);
        s.classList.toggle("slick-active", active);
        s.setAttribute("aria-hidden", active ? "false" : "true");
      });
      [[prev, cur === 0], [next, cur >= maxIndex()]].forEach(function (b) {
        if (!b[0]) return;
        b[0].classList.toggle("slick-disabled", b[1]);
        b[0].setAttribute("aria-disabled", String(b[1]));
      });
    }
    if (prev) prev.addEventListener("click", function () { if (cur > 0) { cur--; render(true); } });
    if (next) next.addEventListener("click", function () { if (cur < maxIndex()) { cur++; render(true); } });
    var sx = null;
    slider.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener("touchend", function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (dx < -40 && cur < maxIndex()) { cur++; render(true); }
      else if (dx > 40 && cur > 0) { cur--; render(true); }
    }, { passive: true });
    window.addEventListener("resize", function () { render(false); });
    render(false);
  }

  /* ---- product slider: pre-rendered slick DOM, 2 per view PC / 1 SP ---- */
  var productSlider = document.getElementById("ProductIntroSlick");
  if (productSlider) wire(productSlider, function () { return isSp() ? 1 : 2; });

  /* ---- app points + other items: slick on SP only, plain layout on PC
         (same as the site's shared_child.js initSlickIfMobile/unslick) ---- */
  [".app-01-point-slider", ".products-others-slider"].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (!el) return;
    var originalHTML = el.innerHTML;
    var built = false;
    function build() {
      var kids = Array.prototype.slice.call(el.children);
      var list = document.createElement("div");
      list.className = "slick-list draggable";
      list.setAttribute("aria-live", "polite");
      var track = document.createElement("div");
      track.className = "slick-track";
      track.setAttribute("role", "listbox");
      track.style.opacity = "1";
      track.style.width = "15000px";
      kids.forEach(function (k, i) {
        k.classList.add("slick-slide");
        k.setAttribute("data-slick-index", String(i));
        track.appendChild(k);
      });
      list.appendChild(track);
      el.innerHTML = "";
      el.appendChild(list);
      el.classList.add("slick-initialized", "slick-slider");
      wire(el, function () { return 1; });
      built = true;
    }
    function destroy() {
      el.classList.remove("slick-initialized", "slick-slider");
      el.innerHTML = originalHTML;
      built = false;
    }
    function sync() {
      if (isSp() && !built) build();
      else if (!isSp() && built) destroy();
    }
    sync();
    window.addEventListener("resize", sync);
  });

  /* ---- info modal (詳しく見る) — same logic as the page's script.js ---- */
  var openButtons = document.querySelectorAll(".js-sofybe-modal-open button");
  var modals = document.querySelectorAll(".js-sofybe-modal");
  var closeButtons = document.querySelectorAll(".js-sofybe-modal-close button");
  openButtons.forEach(function (btn, i) {
    btn.addEventListener("click", function () { modals[i].classList.add("is-active"); });
  });
  closeButtons.forEach(function (btn, i) {
    btn.addEventListener("click", function () { modals[i].classList.remove("is-active"); });
  });
  window.addEventListener("click", function (e) {
    modals.forEach(function (m) { if (e.target === m) m.classList.remove("is-active"); });
  });

  /* ---- EC modal — same logic as sofybe_ec_modal.js ---- */
  var overlay = document.createElement("div");
  overlay.id = "ec-modal-overlay";
  overlay.style.display = "none";
  document.body.appendChild(overlay);
  var contents = Array.prototype.slice.call(document.querySelectorAll(".uc-js-modal-inline-content"));
  function closeEc() {
    overlay.style.display = "none";
    contents.forEach(function (c) { c.classList.remove("uc-modal-inline-00", "uc-is-open"); });
    document.body.classList.remove("uc-is-ec-modal-open");
  }
  overlay.addEventListener("click", closeEc);
  document.querySelectorAll(".uc-js-modal-btn-close").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); closeEc(); });
  });
  document.querySelectorAll(".sofybe-eclink-modal a").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var href = a.getAttribute("href") || "";
      var id = href.indexOf("#") >= 0 ? href.slice(href.indexOf("#") + 1) : "";
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      overlay.style.display = "block";
      target.classList.add("uc-modal-inline-00", "uc-is-open");
      document.body.classList.add("uc-is-ec-modal-open");
    });
  });
})();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", ironCheckkitInit);
} else {
  ironCheckkitInit();
}
